import React from 'react';
import ProductCard from '../productCard';
import { useProductRecommendations } from './useProductRecommendations';
import { ProductRecommendationsProps } from '../interfaces';
import './productRecommendations.scss';

const ProductRecommendations: React.FC<ProductRecommendationsProps> = ({ productId }) => {
  const { products, isLoading } = useProductRecommendations(productId);

  if (!productId || (!isLoading && products.length === 0)) {
    return null;
  }

  return (
    <section className="product-recommendations" aria-labelledby="product-recommendations-title">
      <div className="product-recommendations__heading">
        <p>You may also like</p>
        <h2 id="product-recommendations-title">More from this collection</h2>
      </div>

      <div className="product-recommendations__track" aria-live="polite">
        {isLoading && Array.from({ length: 4 }, (_, index) => (
          <div className="product-recommendations__skeleton" key={index} aria-label="Loading product" />
        ))}
        {!isLoading && products.map((product) => (
          <div className="product-recommendations__item" key={product.id}>
            <ProductCard
              product={product}
              showMaterialSelector={false}
              showLikeButton
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductRecommendations;
